import axios from "axios";
import { IDM_SERVER_BASE_URL } from "../Constants";
import EventBus from "../Components/CommonComponent/EventBus";

export const API_URL = IDM_SERVER_BASE_URL + "/v2/api";

class ConfigsService {
    getConfigs = async () => {
        const response = await axios.get(`${API_URL}/Configs`);

        if (response.data.response == null) {
            throw new Error(response.data.errors?.[0]?.message || "Request failed.");
        }

        return response.data.response;
    };

    GetConfigsPerPage = async (searchDTO) => {
        var request = {
            request: searchDTO,
        };
        const response = await axios.post(`${API_URL}/ConfigSearch`,
            request,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        if (response.status === 401) {
            EventBus.dispatch("Logout");
        }

        if (response.data.errors != null && response.data.errors.length != 0) {
            if (response.data.errors[0].message == "Tenant not selected") {
                EventBus.dispatch("SelectTenant");
            }
        }

        if (response.data.response == null) {
            throw new Error(response.data.errors?.[0]?.message || "Request failed.");
        }

        return response.data.response;
    }

    getConfig = async (configKey) => {
        const response = await axios.get(`${API_URL}/Configs/${configKey}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    };

    createConfig = async (configDTO) => {
        var request = {
            request: configDTO,
        };
        const response = await axios.post(`${API_URL}/Configs`, request, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    };

    updateConfig = async (configDTO) => {
        var request = {
            request: configDTO,
        };
        const response = await axios.put(`${API_URL}/Configs/${configDTO.ConfigKey}`, request, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    };

    deleteConfig = async (configKey) => {
        const response = await axios.delete(`${API_URL}/Configs/${configKey}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    };

    BulkConfigDelete = async (configKey) => {
        var request = {
            request: configKey,
        };
        axios.defaults.withCredentials = true;
        const response = await axios.post(
            `${API_URL}/BulkConfigDelete`,
            request,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            },
            { withCredentials: true }
        );
        return response.data;
    };
}
export default new ConfigsService();
